import React from 'react';

import Container from '@src/components/reusable/Container';

import Logo from '@src/assets/images/planne-logo-color.svg';
import { FooterContainer, Content, LogoContainer } from './styles';

export const Footer = () => {
  return (
    <FooterContainer className='footer'>
      <Container>
        <Content>
          <LogoContainer>
            <Logo />
          </LogoContainer>

          <span>© Planne</span>
        </Content>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
